import { render } from "./HealthLog.vue?vue&type=template&id=2a226645&scoped=true"
import script from "./HealthLog.vue?vue&type=script&lang=js"
export * from "./HealthLog.vue?vue&type=script&lang=js"

import "./HealthLog.vue?vue&type=style&index=0&id=2a226645&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1115173202/src/asistomedia-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a226645"]])

export default __exports__